'use client';

import { useTargetType } from '../../../store/projectStore';
import { TARGET_TYPE } from '../../../utils/target-scope.utils';
import { ExternalNetworkGraphTab } from '../ExternalNetworkGraphTab';
import { InternalNetworkGraphTab } from '../InternalNetworkGraphTab';

export function NetworkGraphContent() {
  const targetType = useTargetType();

  if (targetType === TARGET_TYPE.EXTERNAL_NETWORK) {
    return <ExternalNetworkGraphTab />;
  }

  return <InternalNetworkGraphTab />;
}
